import {
  basePostOption,
  makeAjaxJson,
  makeAjaxJsonWithOption,
  makeFetchJson,
} from './util';

export const checkMobileExist = ({ cellphone }) =>
  makeFetchJson('/api/mobilephones/exist')({ cellphone });

export const sendRegister = makeAjaxJson('/api/users');

export const getCode = ({ cellphone, scope }) =>
  makeFetchJson('/api/mobilephones/getCode')({ cellphone, scope });

export const login = ({ cellphone, password }) =>
  makeAjaxJson('/api/users/login')({ cellphone, password });

export const resetPassword = ({ cellphone, code, new_password }) =>
  makeAjaxJson('/api/users/resetPassword')({ cellphone, code, new_password });

export const update = payload => makeAjaxJsonWithOption({
  ...basePostOption,
  method: 'PATCH',
})('/api/users/me')(payload);

export const syncAvatar = () => makeAjaxJsonWithOption({
  ...basePostOption,
  method: 'GET',
})('/api/users/syncAvatar')();

export const changePassword = ({ old_password, new_password }) => makeAjaxJson('/api/users/me/password')({
  old_password, new_password
});

export const refreshUserInfo = () => makeAjaxJsonWithOption({
  ...basePostOption,
  method: 'GET',
})('/api/users/me')();

export const logout = () => makeAjaxJsonWithOption({
  ...basePostOption,
  method: 'GET',
})('/api/users/logout')();



// WEBPACK FOOTER //
// ./src/api/user.js